import React from "react";
import Modal from "../../elements/front/Modal";
import ManageCompany from "../../../pages/front/ManageCompany";

const CompanyEditModal = ({ isOpen, onClose, organization }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={"Edit Company Details"}
      titleClass={"text-base md:text-xl"}
      modalBodyClass="md:h-[90vh]"
      bodyClasses={"md:p-0"}
    >
      {isOpen && (
        <div className="md:h-screen">
          <ManageCompany
            data={organization}
            close={onClose}
            getResponse={() => {
              onClose();
            }}
          />
        </div>
      )}
    </Modal>
  );
};

export default CompanyEditModal;
